import React from 'react';
import { IField, IProtocol } from '../../../../../shared/interfaces';
import DynamicForm from '../../../../DynamicForm/DynamicForm';
import { RootState } from '../../../../../store';
import { connect, ConnectedProps, useSelector } from 'react-redux';
import CircleLoader from '../../../../Loader/CircleLoader/CircleLoader';


const mapState = (state: RootState) => ({
    sendTypeFields: state.printAndSendWizardReducer.sendTypePrintAndSendFields,
    codiciLavorazione: state.printAndSendWizardReducer.codiciLavorazione,
})
const mapDispatch = {

}
const connector = connect(mapState, mapDispatch);

type PropsFromRedux = ConnectedProps<typeof connector>

export interface FormSendTypeProps {
    loading?: boolean
    extraCssClass?: string
    protocol?: IProtocol
    onInputChangedHandler: (newField: IField) => void
}

type Props = FormSendTypeProps & PropsFromRedux

const FormSendTypeProps: React.FunctionComponent<Props> = (props) => {
    let loading = props.loading !== undefined ? props.loading : false;

    return (
        <React.Fragment>

            <CircleLoader loaderClass='loader-large' loading={loading} />

            <DynamicForm
                fields={props.sendTypeFields}
                onInputChangedHandler={(newField) => { props.onInputChangedHandler(newField) }}
            />

        </React.Fragment>
    );
}

export default connector(FormSendTypeProps);